module.exports = __webpack_public_path__ + "fonts/VIC-SemiBold.woff2";